function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import { Layout, Menu, message } from 'antd';
import { PeopleFill, BuildingCheck, CalendarEventFill, AwardFill, CashCoin, QrCodeScan, Power } from 'react-bootstrap-icons';
import { Link, Outlet } from "react-router-dom";
import { Container, Col, Row } from 'react-bootstrap';
import Common from '../../components/includes/Common';
import { useNavigate } from 'react-router-dom';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Header = Layout.Header,
  Content = Layout.Content,
  Footer = Layout.Footer,
  Sider = Layout.Sider;
var SubMenu = Menu.SubMenu;
var AdminPanel = function AdminPanel() {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    collapsed = _useState2[0],
    setCollapsed = _useState2[1];
  var navigate = useNavigate();
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    authProcessing = _useState4[0],
    setAuthProcessing = _useState4[1];
  var _useState5 = useState(Common.currentUser != null && Common.currentUser != 'undefined'),
    _useState6 = _slicedToArray(_useState5, 2),
    localDataExists = _useState6[0],
    setLocalDataExists = _useState6[1];
  var onCollapse = function onCollapse(collapsed) {
    setCollapsed(collapsed);
  };
  var hClick = function hClick(e) {
    if (e.key == 'quit') {
      axios.post(Common.baseApiUrl + 'sulogout').then(function (response) {
        if (response.data.status == 200) {
          localStorage.removeItem('userData');
          navigate('/az/auth');
        }
      })["catch"](function (error) {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      });
    }
  };
  useEffect(function () {
    if (localStorage.getItem('userData') == 'null' || localStorage.getItem('userData') == 'undefined') {
      navigate('/az/auth');
      location.reload();
    } else {
      axios.post(Common.baseApiUrl + 'authenticateadmin', {
        aid: JSON.parse(localStorage.getItem('userData')).id
      }).then(function (response) {
        setAuthProcessing(false);
        if (response.data.authenticated == true) {
          console.log('Auth success');
          localStorage.setItem('userData', JSON.stringify(response.data.user));
        } else {
          console.log('Auth failed');
          localStorage.removeItem('userData');
          navigate('/az/auth');
          location.reload();
        }
      })["catch"](function (error) {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      });
    }
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: localDataExists && /*#__PURE__*/_jsxs(Layout, {
      style: {
        minHeight: '100vh'
      },
      children: [/*#__PURE__*/_jsx(Sider, {
        style: {
          background: '#F5EEE5'
        },
        collapsible: true,
        collapsed: collapsed,
        onCollapse: onCollapse,
        children: /*#__PURE__*/_jsxs(Menu, {
          onClick: hClick,
          theme: "light",
          style: {
            background: '#F5EEE5'
          },
          defaultSelectedKeys: ['dash'],
          mode: "inline",
          children: [/*#__PURE__*/_jsx(Menu.Item, {
            icon: /*#__PURE__*/_jsx(QrCodeScan, {
              size: 24
            }),
            children: /*#__PURE__*/_jsx(Link, {
              to: "/az/panel/admin-flash-ticket",
              children: /*#__PURE__*/_jsx("b", {
                children: "Scan"
              })
            })
          }, "events"), /*#__PURE__*/_jsx(Menu.Item, {
            icon: /*#__PURE__*/_jsx(CalendarEventFill, {
              size: 24
            }),
            children: /*#__PURE__*/_jsx(Link, {
              to: "/az/panel/manage-events",
              children: /*#__PURE__*/_jsx("b", {
                children: "Ev\xE8nements"
              })
            })
          }, "events"), /*#__PURE__*/_jsx(Menu.Item, {
            icon: /*#__PURE__*/_jsx(BuildingCheck, {
              size: 24
            }),
            children: /*#__PURE__*/_jsx(Link, {
              to: "/az/panel/manage-organizations",
              children: /*#__PURE__*/_jsx("b", {
                children: "Structures"
              })
            })
          }, "comps"), /*#__PURE__*/_jsx(Menu.Item, {
            icon: /*#__PURE__*/_jsx(AwardFill, {
              size: 24
            }),
            children: /*#__PURE__*/_jsx(Link, {
              to: "/az/panel/manage-votes",
              children: /*#__PURE__*/_jsx("b", {
                children: "Votes"
              })
            })
          }, "votes"), /*#__PURE__*/_jsx(Menu.Item, {
            icon: /*#__PURE__*/_jsx(CashCoin, {
              size: 24
            }),
            children: /*#__PURE__*/_jsx(Link, {
              to: "/az/panel/transactions",
              children: /*#__PURE__*/_jsx("b", {
                children: "Transactions"
              })
            })
          }, "cash"), /*#__PURE__*/_jsx(Menu.Item, {
            icon: /*#__PURE__*/_jsx(PeopleFill, {
              size: 24
            }),
            children: /*#__PURE__*/_jsx(Link, {
              to: "/az/panel/manage-users",
              children: /*#__PURE__*/_jsx("b", {
                children: "Utilisateur"
              })
            })
          }, "user"), /*#__PURE__*/_jsx(Menu.Item, {
            icon: /*#__PURE__*/_jsx(Power, {
              color: "#F57645",
              size: 24
            }),
            children: /*#__PURE__*/_jsx(Link, {
              to: "#",
              children: /*#__PURE__*/_jsx("b", {
                children: "QUITTER"
              })
            })
          }, "quit")]
        })
      }), /*#__PURE__*/_jsxs(Layout, {
        className: "site-layout",
        children: [/*#__PURE__*/_jsx(Header, {
          className: "site-layout-background",
          style: {
            padding: 0
          },
          children: /*#__PURE__*/_jsx(Container, {
            children: /*#__PURE__*/_jsx(Row, {
              children: /*#__PURE__*/_jsx(Col, {
                children: /*#__PURE__*/_jsx("div", {
                  style: {
                    width: '120px'
                  },
                  children: /*#__PURE__*/_jsx("img", {
                    src: "drawables/nl1_rm.png",
                    style: {
                      width: '100%'
                    }
                  })
                })
              })
            })
          })
        }), /*#__PURE__*/_jsx(Content, {
          style: {
            margin: '0 16px'
          },
          children: /*#__PURE__*/_jsx(Outlet, {})
        }), /*#__PURE__*/_jsx(Footer, {
          style: {
            textAlign: 'center'
          },
          children: "GuisoftLab \xA92022 Tous droits r\xE9serv\xE9s"
        })]
      })]
    })
  });
};
export default AdminPanel;